import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';

const defaultStyles = css``;

/**
 * Renders a `form` element.
 *
 * @public
 * @author Connor Taylor
 */
const Form = makeThemedComponent({
  themeKey: `Form`,
  component: `form`,
  defaultStyles,
});

export { defaultStyles };

/** @component */
export default Form;
